// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import ChangePasswordDialog from '../dialogs/ChangePasswordDialog';
import i18n from '../../i18n';
import { MenuItem } from '@mui/material';
import PasswordIcon from '@mui/icons-material/Password';
import { SYSTEM_ROLES } from '../../config/roles.config';
import { getUserNameByRole } from '../../utils/cells';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';

export default class UsersPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'users';
        this.Server = this.props.context.getState().server.users;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['firstName', 'lastName'];

        const defaultHead = [
            {
                id: 'firstName',
                label: 'firstName',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'lastName',
                label: 'lastName',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'role',
                label: 'role',
                alignRight: false,
                cell: 'RoleSelect',
                show: 'name',
                from: 'roles',
                object: 'role',
                fullObject: true,
                // translate: 'enums',
                // needTranslate: (value) => value?.isDefault, // maybe used in future
                displayGrid: true,
                extraRender: (value, row) => getUserNameByRole(value, row)
                // enableCopyExtraRender: true,
            },
            {
                id: 'merchantId',
                label: 'merchant',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                object: 'merchant',
                displayGrid: false,
                from: 'publicMerchants',
                required: true,
                showIfDialog: (data) =>
                    data.role?.systemRole === SYSTEM_ROLES.MERCHANT
            },
            {
                id: 'providerId',
                label: 'provider',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                from: 'publicProviders',
                object: 'provider',
                displayGrid: false,
                required: true,
                showIfDialog: (data) =>
                    data.role?.systemRole === SYSTEM_ROLES.PSP
            },
            {
                id: 'agentId',
                label: 'agent',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                from: 'publicAgents',
                object: 'agent',
                displayGrid: false,
                required: true,
                showIfDialog: (data) =>
                    data.role?.systemRole === SYSTEM_ROLES.AGENT
            },
            {
                id: 'email',
                label: 'email',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'twoFactorEnabled',
                label: 'twoFactorAuth',
                alignRight: false,
                cell: 'Enable',
                type: 'boolean',
                role: 'admin_ecoo',
                displayGrid: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            },
            {
                id: 'isActive',
                label: 'isActive',
                alignRight: false,
                cell: 'Checkbox',
                type: 'boolean',
                displayGrid: true
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head,
            changePassDialogOpen: false,
            activeUserId: null
        };
    }

    static BUSINESS_ENTITY_FIELDS = ['merchantId', 'providerId', 'agentId'];

    static SYSTEM_ROLE_TO_ENTITY = {
        [SYSTEM_ROLES.MERCHANT]: { id: 'merchantId', label: 'merchant' },
        [SYSTEM_ROLES.PSP]: { id: 'providerId', label: 'provider' },
        [SYSTEM_ROLES.AGENT]: { id: 'agentId', label: 'agent' }
    };

    validateBusinessEntity(data) {
        const entity =
            UsersPage.SYSTEM_ROLE_TO_ENTITY[data.role?.systemRole];
        if (entity && !data[entity.id]) {
            return [
                `${i18n.t(`columns.${entity.label}`)}: ${i18n.t(
                    'errors.fieldRequired'
                )}`
            ];
        }
        return null;
    }

    normalizeBusinessEntity(data) {
        const entity =
            UsersPage.SYSTEM_ROLE_TO_ENTITY[data.role?.systemRole];
        const cleared = { ...data };
        UsersPage.BUSINESS_ENTITY_FIELDS.forEach((field) => {
            if (field !== entity?.id) {
                cleared[field] = null;
            }
        });
        return cleared;
    }

    async handleDialogOnSave(data, mode) {
        const validationError = this.validateBusinessEntity(data);
        if (validationError) {
            this.setState({ dialogError: validationError });
            return;
        }
        await super.handleDialogOnSave(
            this.normalizeBusinessEntity(data),
            mode
        );
    }

    handleOpenModifiedReasonDialog = (data) => {
        const validationError = this.validateBusinessEntity(data);
        if (validationError) {
            this.setState({ dialogError: validationError });
            return;
        }
        this.setState({
            modifiedDialogOpen: true,
            dialogData: this.normalizeBusinessEntity(data)
        });
    };

    openChangePassDialog() {
        this.handleCloseMenu();
        this.setState({
            changePassDialogOpen: true,
            activeUserId: this.state.menuClickItemId
        });
    }

    renderCustomMenuItems() {
        return (
            <MenuItem onClick={() => this.openChangePassDialog()}>
                <PasswordIcon sx={{ mr: 2 }} />
                {i18n.t('buttons.changePass')}
            </MenuItem>
        );
    }

    renderCustom() {
        return (
            <ChangePasswordDialog
                open={this.state.changePassDialogOpen}
                userId={this.state.activeUserId}
                onClose={() =>
                    this.setState({
                        changePassDialogOpen: false,
                        activeUserId: null
                    })
                }
            />
        );
    }
}
